$(function () {
    $('#userpassword, #userpassword2').on('keyup', function () {
        if ($('#userpassword').val() != '' && $('#userpassword2').val() != '') {

            if ($('#userpassword').val() == $('#userpassword2').val()) {
                $('.invalid-feedback.pwds').hide();
                $('.pwds').removeClass('is-invalid');
            }
            else {
                $('.invalid-feedback.pwds').show();
                $('.pwds').addClass('is-invalid');
            }
        }
        else {
            $('.invalid-feedback.pwds').hide();
            $('.pwds').removeClass('is-invalid');
        }
    });
})
